// extracted by mini-css-extract-plugin
export var action = "styles-module--action--fb86b";
export var action__btn = "styles-module--action__btn--9dc5a";
export var actions = "styles-module--actions--44578";
export var active = "styles-module--active--65e43";
export var code = "styles-module--code--0c838";
export var copied = "styles-module--copied--56feb";
export var coupon = "styles-module--coupon--bf012";
export var has__coupon = "styles-module--has__coupon--0e830";
export var label = "styles-module--label--3d48f";
export var price = "styles-module--price--1dbd5";
export var prices = "styles-module--prices--f5955";
export var regular = "styles-module--regular--e4746";
export var shop = "styles-module--shop--ec458";
export var shop__name = "styles-module--shop__name--2a181";
export var shop_actions = "styles-module--shop_actions--2f55c";
export var show__more__btn = "styles-module--show__more__btn--da867";